import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { OnboardingStore } from '../../store/onboarding.store';

export type WelcomeDialogResult = 'start' | 'later';

/** Boas-vindas: objetivo, benefícios e o que já está pronto pelos dados da empresa. */
@Component({
  selector: 'app-onboarding-welcome-dialog',
  standalone: true,
  imports: [MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './onboarding-welcome-dialog.component.html',
  styleUrl: './onboarding-welcome-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingWelcomeDialogComponent {
  private readonly store = inject(OnboardingStore);
  private readonly dialogRef = inject(MatDialogRef<OnboardingWelcomeDialogComponent, WelcomeDialogResult>);

  readonly definition = this.store.definition;

  /** Etapas que já nasceram prontas ("Já identificamos: ..."). */
  readonly readySteps = computed(() =>
    (this.store.state()?.steps ?? [])
      .filter((step) => step.status === 'COMPLETED' && step.readyFromStart)
      .map((step) => this.store.stepDefinition(step.key)?.titleKey)
      .filter((key): key is string => !!key)
  );

  /** Quem já chega com a empresa pronta recebe o texto "falta só..." no lugar do genérico. */
  readonly leadKey = computed(() => {
    const welcome = this.definition()?.welcome;
    const useReady = this.readySteps().length > 0 && !!welcome?.leadReadyKey;
    return (useReady ? welcome?.leadReadyKey : welcome?.leadKey) ?? '';
  });

  close(result: WelcomeDialogResult): void {
    this.dialogRef.close(result);
  }
}
